import React, { useState, useEffect, useMemo, useRef } from 'react';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment/moment';
import { useNavigate, useLocation } from 'react-router-dom';
const SecurityIn = () => {
  const [validationErrors, setValidationErrors] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [searchInput, setSearchInput] = useState('');
 
  const [formData, setFormData] = useState({
    gsrs: '',
    badgeId: '',
    name: '',
    sewadarMobileNo: '',
    sewadarAltMobileNo: '',
    cameFrom: '',
    purpose: '',
    vehicleNumber: '',
    driverName: '',
    mobileNo: '',
    entryDate: new Date().toISOString().split('T')[0], // Prefill with today's date
    entryTime: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5), // Prefill with current time (HH:mm)
    documentStatus: '',
    documentNo: '',
    documentDate: '',
    ledgerName: '',
    itemGroups: [],
    remarks: '',
    bilwaVehicle: 'No'
  });
  const navigate = useNavigate()
  const location = useLocation()
  const [submittedData, setSubmittedData] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editSecurityId, setSecurityId] = useState(null);
  const code = localStorage.getItem('code');
  const token = localStorage.getItem('token');
  const [itemGroups, setItemGroups] = useState([]);
  const [ledgerGroups, setLedgerGroups] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [purposes, setPurposes] = useState([]);
  const [securityIns, setSecurityIns] = useState([]);
  const [securitySewadars, setSecuritySewadars] = useState([]);
  const entryData = location?.state?.entry;
  const email = localStorage.getItem('email');
      useEffect(() => {
  
        if (entryData) {
          
          handleEdit(entryData);
        }
      }, [entryData]);
  let documentOptions = []
  if (formData.cameFrom != 'Not Known') {


    documentOptions = [
      { value: 'original', label: 'Original Document Collected' },
      { value: 'copyDocs', label: 'Copy of Document Collected' },
      { value: 'Received on Paper / Kanta / Parchi', label: 'Received on Paper / Kanta / Parchi' },
      { value: 'Inward Entry Memo Issued', label: 'Inward Entry Memo Issued' },
    ];
  } else {
    documentOptions = [
      { value: 'Received on Paper / Kanta / Parchi', label: 'Received on Paper / Kanta / Parchi' },
      { value: 'Inward Entry Memo Issued', label: 'Inward Entry Memo Issued' },
    ];
  }
  const badgeOptions = securitySewadars.map((s) => ({
    value: s.badgeId,
    label: `${s.badgeId}`,
    name: s?.fullName,
    sewadarMobileNo: s.mobileNo,
    alternateMobileNo: s.alternateMobileNo,
  }));




const fetchSewadars = async () => {
  try {
    const departments = ["Security", "Satsang", "Office"];

    const res = await apiClient.get(
      `${SERVER_BASE}/getOperatorsByDepartment/${code}`,
      {
        params: {
          department: departments.join(",") // Security,Satsang
        }
      }
    );

    setSecuritySewadars(res.data);
  } catch (error) {
    console.error("Error fetching sewadars:", error);
    // Swal.fire("Error", "Failed to fetch sewadars", "error");
  }
};


  const fetchVehicleDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getVehicleDetails`);

      // Create options with value & label as vehicleNo
      const options = response.data.map(v => ({
        value: v.vehicleNo,
        label: v.vehicleNo,
      }));
      setVehicleOptions(options);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };
  useEffect(() => {
    fetchSewadars();
  }, [code]);

  const handleInputChange = (e) => {
    fetchPurpposeByLedger();
    fetchLedgerMasterByLedger();

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove red instantly when user enters something
    if (value?.trim() !== "") {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleBadgeIdChange = (selected) => {
    if (!selected) {
      setFormData((prev) => ({
        ...prev,
        badgeId: null,
        name: "",
        sewadarMobileNo: "",
        sewadarAltMobileNo: "",
      }));

      // Keep it red when unselected
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        badgeId: "Badge ID is required",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        badgeId: selected,
        name: selected?.name,
        sewadarMobileNo: selected?.sewadarMobileNo,
        sewadarAltMobileNo: selected?.alternateMobileNo,
      }));

      // Remove red instantly when selected
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        badgeId: undefined,
      }));
    }
  };
  const validateForm = () => {
    const errors = {};

    if (!formData.gsrs.trim()) {
      errors.gsrs = 'SR Number is required.';
    }
    if (!formData?.badgeId) {
      errors.badgeId = 'BadgeId is required.';
    }
    // if (formData.documentStatus.trim() && (formData.documentStatus != 'Received on Paper / Kanta / Parchi' || formData.documentStatus != 'Inward Entry Memo Issued')) {
    //   if (!formData.documentNo.trim())
    //     errors.documentNo = 'Document No is required.';
    // }
    // if (formData.documentStatus.trim() && formData.documentStatus != 'Received on Paper / Kanta / Parchi' || formData.documentStatus != 'Inward Entry Memo Issued') {
    //   if (!formData.documentDate.trim())
    //     errors.documentDate = 'Document Date is required.';
    // }
    if (!formData.cameFrom.trim()) {
      errors.cameFrom = 'Came From is required.';
    }
    if (!formData.documentStatus.trim()) {
      errors.documentStatus = 'Please Doc Select Status';
    }
    if (!formData.purpose.trim() && formData.cameFrom != 'Not Known') {
      errors.purpose = 'Purpose is required.';
    }
    if (!formData.mobileNo.trim()) {
      errors.mobileNo = 'Mobile No is required.';
    }
    if (
      ['RSSB Center', 'Local Supplier', 'Zonal Purchase Supplier', 'Transporters'].includes(formData.cameFrom) &&
      !formData.vehicleNumber.trim()
    ) {
      errors.vehicleNumber = 'Vehicle No is required';
    }

    if (
      ['Sewadar', 'Sangat'].includes(formData.cameFrom) &&
      !formData.driverName.trim()
    ) {
      errors.driverName = 'Name is required';
    }

    if (
      ['RSSB Center', 'Local Supplier', 'Zonal Purchase Supplier', 'Transporters'].includes(formData.cameFrom)
    ) {
      if (!formData.entryDate.trim()) {
        errors.entryDate = 'Entry Date is required for the selected "Came From".';
      }
      if (!formData.entryTime.trim()) {
        errors.entryTime = 'Entry Time is required for the selected "Came From".';
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };
  useEffect(() => {
    fetchLedgerGroups();
    fetchSecurityIn();
    fetchVehicleDetails();
    // fetchPurpposeByLedger();
    fetchItemGroups();
  }, []);
  const previousCameFrom = useRef(formData.cameFrom);

  useEffect(() => {
    if (formData.cameFrom && formData.cameFrom !== previousCameFrom.current) {
      previousCameFrom.current = formData.cameFrom;
      fetchPurpposeByLedger();
      fetchLedgerMasterByLedger();
    }
  }, [formData.cameFrom]);

  const fetchLedgerGroups = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/ledger-groups', {
        params: { code }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setLedgerGroups(response.data);
    } catch (error) {
      console.error('Error fetching ledger groups:', error);
    }
  };
  const fetchPurpposeByLedger = async () => {
    if (!formData.cameFrom) {
      return; // Don't fetch if cameFrom is not set
    }

    try {
      const response = await apiClient.get(SERVER_BASE + '/getPurposeByLedgerForChallan', {
        params: { ledgerName: formData?.cameFrom, code: code, type: 'si' },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setPurposes(response.data);
    } catch (error) {
      console.error('Error fetching purposes by ledger:', error);
    }
  };

  const fetchSecurityIn = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/getSecurityIn', {
        params: { code: code }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setSecurityIns(response.data);
    } catch (error) {
      console.error('Error fetching Sewadars:', error);
    }
  };

  const fetchLedgerMasterByLedger = async () => {
    if (!formData.cameFrom) {
      return; // Don't fetch if cameFrom is not set
    }

    try {
      const response = await apiClient.get(SERVER_BASE + '/getLedgerMasterByLedger', {
        params: { code, ledgerName: formData.cameFrom }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
      setLedgers(response.data);
    } catch (error) {
      console.error('Error fetching ledger master:', error);
    }
  };
  const fetchItemGroups = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/item-groups", {
        params: { code }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
      setItemGroups(
        response.data.map((group) => ({
          value: group.groupName,
          label: group.groupName,
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    Swal.fire({
      title: editSecurityId !== null ? 'Confirm Update' : 'Confirm Add',
      text: editSecurityId !== null ? 'Are you sure you want to update this entry?' : 'Are you sure you want to add this entry?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {


        let response
        try {
          if (editSecurityId !== null) {
            const newData = { ...formData, code, itemGroups: formData.itemGroups?.map((d) => d.value) || [],updatedBy:email };
            await apiClient.post(`${SERVER_BASE}/updateSecurity-in/${editSecurityId}`, {
              newData, headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              }
            });
            fetchSecurityIn();
            setSecurityId(null);
          } else {
            const newData = { ...formData, code,createdBy:email };
            // Create new purposea
            response = await apiClient.post(SERVER_BASE + '/security-in', newData, {
              headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              }
            });
            fetchSecurityIn();
          }

          resetForm();
          setShowForm(false);
          navigate('../vehicleIn')
          Swal.fire(editSecurityId ? 'Updated!' : 'Created!', editSecurityId ? '' : `Your SI Number is ${response?.data?.siCode}`, 'success');
        } catch (error) {
          console.error('Error saving entry:', error);
          Swal.fire('Error', error.response.data.message, 'error');
        }
      }
    });

  };

  const handleEdit = (entry) => {
    setShowForm(true)
    setIsEditing(true);
    setSecurityId(entry.id)
    setFormData((prevState) => ({
      ...prevState, // Preserve the existing formData state
      cameFrom: entry.cameFrom,
      purpose: entry.purpose,
      vehicleNumber: entry.vehicleNumber,
      driverName: entry.driverName,
      mobileNo: entry.mobileNo,
      entryDate: entry.entryDate,
      entryTime: entry.entryTime,
      documentStatus: entry.documentStatus,
      documentDate: entry.documentDate,
      documentNo: entry.documentNo,
      ledgerName: entry.ledgerName,
      remarks: entry.remarks,
      gsrs: entry.gsrs,
      badgeId: { value: entry.badgeId, label: entry.badgeId },
      name: entry.sewadarName,
      sewadarMobileNo: entry?.sewadarMobileNo,
      sewadarAltMobileNo: entry?.sewadarAlternateMob,
      bilwaVehicle: entry?.bilwaVehicle
    }));
    const itemArray = Array.isArray(entry.itemGroup)
      ? entry.itemGroup
      : entry.itemGroup
        ? entry.itemGroup.split('~') // If the string is separated by `~`
        : [];
    setFormData((prevState) => ({
      ...prevState,
      itemGroups: itemArray.map((item) => ({ value: item, label: item })), // Assuming you want to store this array in `itemGroup`
    }));

  };
  useEffect(() => {
    if (formData.cameFrom && formData.cameFrom !== previousCameFrom.current) {
      previousCameFrom.current = formData.cameFrom;
      fetchPurpposeByLedger();
      fetchLedgerMasterByLedger();
    }
  }, [formData.cameFrom]);


  const handleDelete = async (row) => {
    const { id } = row;  // Destructure the necessary fields from row.original

    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this security in entry? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        const response = await apiClient.delete(SERVER_BASE + '/deleteSecurityIn', {
          data: { id, code }, headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });

        fetchSecurityIn();

        Swal.fire({
          icon: 'success',
          title: response.data.message,
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error deleting Entry:', error);
        Swal.fire({
          icon: 'error',
          title: error?.response?.data?.error,
          toast: true,
          position: 'top-end',
          showConfirmButton: true,
        });
      }
    }
  };

  const resetForm = () => {
    setIsEditing(false)
    setSecurityId(null)
    setFormData({
      cameFrom: '',
      purpose: '',
      vehicleNumber: '',
      driverName: '',
      mobileNo: '',
      entryDate: new Date().toISOString().split('T')[0], // Prefill with today's date
      entryTime: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5), // Prefill with current time (HH:mm)
      documentStatus: '',
      documentNo: '',
      documentDate: '',
      ledgerName: '',
      itemGroups: [],
      remarks: '',
      gsrs: '',
      name: '',
      bilwaVehicle: ''
    });
    setValidationErrors({});
  };

  return (
    <div className="formcontainer mt-5">
      <div className="d-flex">
        <button
          className="btn btn-secondary btn-sm me-2"
          onClick={() => navigate('../vehicleIn')}
        >
          Cancel
        </button>
        <h4 className="m-0">Security In</h4>
      </div>

      <form onSubmit={handleSubmit} className="">
        <div className="row">
          <div className="col-12">
            <h6 className="section-heading">Security Gate Details</h6>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label>SR No</label>
              <input
                type="text"
                name="gsrs"
                value={formData.gsrs}
                onChange={handleInputChange}
                className={`form-control ${!formData.gsrs?.trim() ? 'is-invalid' : ''}`}
              />
              {!formData.gsrs?.trim() && (
                <div className="invalid-feedback"> No is required</div>
              )}
            </div>

            <div className="col-md-3">
              <label>Badge ID</label>
              <Select
                options={badgeOptions}
                value={formData?.badgeId}
                onChange={handleBadgeIdChange}
                className={`${!formData.badgeId ? 'form-control is-invalid' : ''}`}
              />
              {!formData.badgeId && (
                <div className="invalid-feedback">Badge ID is required</div>
              )}
            </div>



            <div className="col-md-3">
              <label>Sewadar Name</label>
              <input
                type="text"
                className="form-control"
                value={formData?.name}
                readOnly
              />
            </div>

            <div className="col-md-3">
              <label>Mobile No</label>
              <input
                type="text"
                className="form-control"
                value={formData.sewadarMobileNo}
                readOnly
              />
            </div>

          </div>
          <div className="col-12">
            <h6 className="section-heading">Transaction Details</h6>
          </div>

          <div className="col-md-3">
            <label>Came From</label>
            <select
              className={`form-control ${!formData.cameFrom ? 'is-invalid' : ''}`}
              name="cameFrom"
              onChange={handleInputChange}
              value={formData.cameFrom}
            >
              <option value="">Select Came From</option>
              {ledgerGroups.map((option) => (
                <option key={option.id} value={option.groupName}>
                  {option.groupName}
                </option>
              ))}
            </select>
            {!formData.cameFrom && (
              <div className="invalid-feedback">Came From is required</div>
            )}
          </div>

          <div className="col-md-3">
            <label>Purpose/Event</label>
            <select
              className={`form-control ${!formData.purpose ? 'is-invalid' : ''}`}
              name="purpose"
              onChange={handleInputChange}
              value={formData.purpose}
            >
              <option value="">Select Purpose</option>
              {purposes.map((option) => (
                <option key={option.id} value={option.purposeName}>
                  {option.purposeName}
                </option>
              ))}
            </select>
            {!formData.purpose && (
              <div className="invalid-feedback">Purpose is required</div>
            )}
          </div>
          <div className="col-md-3">
            <label>Document Status</label>
            <select
              className={`form-control ${!formData.documentStatus ? 'is-invalid' : ''}`}
              name="documentStatus"
              onChange={handleInputChange}
              value={formData.documentStatus}
            >
              <option value="">Select Document Status</option>
              {documentOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {!formData.documentStatus && (
              <div className="invalid-feedback">Please Select Doc Status</div>
            )}
          </div>
          <div className="col-md-3">
            <label>Item Groups</label>
            <Select
              className={`${validationErrors.itemGroups ? 'form-control is-invalid' : ''}`}
              isMulti
              options={itemGroups}
              value={formData.itemGroups}
              onChange={(selected) => handleSelectChange(selected, 'itemGroups')}
            />
            {validationErrors.itemGroups && (
              <div className="invalid-feedback">{validationErrors.itemGroups}</div>
            )}
          </div>

          {/* <div className="col-12">
            <h6 className="section-heading">Document Details</h6>
          </div>
          <div className="col-md-3">
            <label>Bill / Inward Memo No.</label>
            <input
              type="text"
              className={`form-control ${validationErrors.documentNo ? 'is-invalid' : ''}`}
              name="documentNo"
              onChange={handleInputChange}
              value={formData.documentNo}
            />
            {validationErrors.documentNo && (
              <div className="invalid-feedback">{validationErrors.documentNo}</div>
            )}
          </div>

          <div className="col-md-3">
            <label>Bill / Inward Memo Date</label>
            <input
              type="date"
              className={`form-control ${validationErrors.documentDate ? 'is-invalid' : ''}`}
              name="documentDate"
              onChange={handleInputChange}
              value={formData.documentDate}
            />
            {validationErrors.documentDate && (
              <div className="invalid-feedback">{validationErrors.documentDate}</div>
            )}
          </div> */}
          <div className="col-12">
            <h6 className="section-heading">Vehicle Details</h6>
          </div>
          <div className="col-md-2">
            <label>Bilwa Vehicle</label>
            <select
              className={`form-control ${validationErrors.bilwaVehicle ? "is-invalid" : ""}`}
              name="bilwaVehicle"
              onChange={handleInputChange}
              value={formData.bilwaVehicle}
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {validationErrors.bilwaVehicle && (
              <div className="invalid-feedback">{validationErrors.bilwaVehicle}</div>
            )}
          </div>

          <div className="col-md-2">
            <label>Vehicle Number</label>

            {formData.bilwaVehicle === "Yes" ? (
              <>
                <Select
                  name="vehicleNumber"
                  options={vehicleOptions} // [{ value: "RJ14AB1234", label: "RJ14AB1234" }]
                  value={
                    vehicleOptions.find(opt => opt.value === formData.vehicleNumber) || null
                  }
                  onChange={(selected) =>
                    handleInputChange({
                      target: {
                        name: "vehicleNumber",
                        value: selected ? selected.value : "",
                      },
                    })
                  }
                  classNamePrefix="react-select"
                />
                {["RSSB Center", "Local Supplier", "Zonal Purchase Supplier", "Transporters"].includes(
                  formData.cameFrom
                ) &&
                  !formData.vehicleNumber?.trim() && (
                    <div className="text-danger small">Vehicle Number is required</div>
                  )}
              </>
            ) : (
              <>
                <input
                  type="text"
                  name="vehicleNumber"
                  value={formData.vehicleNumber}
                  onChange={handleInputChange}
                  className={`form-control ${["RSSB Center", "Local Supplier", "Zonal Purchase Supplier", "Transporters"].includes(
                    formData.cameFrom
                  ) && !formData.vehicleNumber?.trim()
                    ? "is-invalid"
                    : ""
                    }`}
                />
                {["RSSB Center", "Local Supplier", "Zonal Purchase Supplier", "Transporters"].includes(
                  formData.cameFrom
                ) &&
                  !formData.vehicleNumber?.trim() && (
                    <div className="invalid-feedback">Vehicle Number is required</div>
                  )}
              </>
            )}
          </div>

          <div className="col-md-2">
            <label>Name / Driver Name</label>
            <input
              type="text"
              className={`form-control ${validationErrors.driverName ? 'is-invalid' : ''}`}
              name="driverName"
              onChange={handleInputChange}
              value={formData.driverName}
            />
            {validationErrors.driverName && (
              <div className="invalid-feedback">{validationErrors.driverName}</div>
            )}
          </div>
          <div className="col-md-2">
            <label>Mobile No</label>
            <input
              type="text"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleInputChange}
              className={`form-control ${!formData.mobileNo?.trim() ? 'is-invalid' : ''}`}
            />
            {!formData.mobileNo?.trim() && (
              <div className="invalid-feedback">Mobile No is required</div>
            )}
          </div>

          <div className="col-md-2">
            <label>Entry Date</label>
            <input
              type="date"
              name="entryDate"
              value={formData.entryDate}
              onChange={handleInputChange}
              className={`form-control ${!formData.entryDate ? 'is-invalid' : ''}`}
            />
            {!formData.entryDate && (
              <div className="invalid-feedback">Entry Date is required</div>
            )}
          </div>

          <div className="col-md-2">
            <label>Entry Time</label>
            <input
              type="time"
              name="entryTime"
              value={formData.entryTime}
              onChange={handleInputChange}
              className={`form-control ${!formData.entryTime ? 'is-invalid' : ''}`}
            />
            {!formData.entryTime && (
              <div className="invalid-feedback">Entry Time is required</div>
            )}
          </div>

          <div className="col-12">
            <h6 className="section-heading"></h6>
          </div>


          <div className="col-md-12">
            <label>Remarks</label>
            <input className="form-control" name="remarks" onChange={handleInputChange} value={formData.remarks} />
          </div>
          <div className="col-12 mt-1 text-end">
            <button type="submit" className="btn btn-success">Submit</button>
          </div>
        </div>
      </form>



    </div>
  );
};

export default SecurityIn;
